module.exports = __webpack_public_path__ + "static/img/modelCategoryManage.9ee6acc0.png";